//React
import cx from "classnames";
//Components
import {
  AlphaNumericInput,
  Button,
  Card,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Screen,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
//Styles
import "./styles.scss";
import CartoonMan from "assets/cartoon-man.png";
import PotraitCartoon from "assets/potrait-cartoon.png";
import RightArrowIcon from "assets/icons/right-arrow.svg";
import SatyamImg from "assets/employees/satyam.png";
import TanmayImg from "assets/employees/tanmay.png";
import BhavikImg from "assets/employees/bhavik.png";
import AshwinImg from "assets/employees/ashwin.png";
import ManasImg from "assets/employees/manas.png";
import ChiragImg from "assets/employees/chirag.png";
import LandingImg from "assets/landing-image.svg";
import LinkedInLogo from "assets/social logos/linkedin.svg";
import { ChangeHistory, EventManager, EventNames, validateEmail } from "utils";
import { useDispatch } from "react-redux";
import {
  registerClientApi,
  setGeneralDetails,
  useGeneralDetails,
  useRegisterClientApiDetails,
} from "Slices";
import { toast } from "react-toastify";
import TrustLogo from "assets/trust-logo.svg";
import ROUTE_PATH from "Routes/paths";

const Landing = () => {
  const dispatch = useDispatch();

  //Selectors
  const registerClientDetails = useRegisterClientApiDetails();
  const generalDetails = useGeneralDetails();

  //Constants
  const [email, setEmail] = useState("");
  const [userRegistered, setUserRegistered] = useState(false);
  const [goOTPLessClicked, setGoOTPLessClicked] = useState(false);
  const [storySectionVisibility, setStorySectionVisibility] = useState(false);
  const storySectionRef: any = useRef(null);
  const [missionSectionVisibility, setMissionSectionVisibility] =
    useState(false);
  const missionSectionRef: any = useRef(null);
  const [visionSectionVisibility, setVisionSectionVisibility] = useState(false);
  const visionSectionRef: any = useRef(null);
  const [teamSectionVisibility, setTeamSectionVisibility] = useState(false);
  const teamSectionRef: any = useRef(null);

  useEffect(() => {
    setUserRegistered(
      registerClientDetails?.data?.status === "SUCCESS" &&
        !registerClientDetails?.data?.isExist
    );
    if (
      registerClientDetails?.data?.status === "SUCCESS" &&
      registerClientDetails?.data?.isExist
    ) {
      const endPath = window.localStorage.getItem("token")
        ? "ACTIVITY"
        : "SIGNUP_LOGIN";

      ChangeHistory("push", ROUTE_PATH.DASHBOARD[endPath]);
    }
  }, [registerClientDetails]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll, true);
    EventManager.send(EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.PAGE_VIEW);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const onScroll = (event: any) => {
    const docViewTop = window.pageYOffset;
    const storySectionTop = storySectionRef?.current?.offsetTop - 800;
    const missionSectionTop = missionSectionRef?.current?.offsetTop - 800;
    const visionSectionTop = visionSectionRef?.current?.offsetTop - 800;
    const teamSectionTop = teamSectionRef?.current?.offsetTop - 800;
    if (docViewTop >= storySectionTop && !storySectionVisibility) {
      setStorySectionVisibility(true);
    }
    if (docViewTop >= missionSectionTop && !missionSectionVisibility) {
      setMissionSectionVisibility(true);
    }
    if (docViewTop >= visionSectionTop && !visionSectionVisibility) {
      setVisionSectionVisibility(true);
    }
    if (docViewTop >= teamSectionTop && !teamSectionVisibility) {
      setTeamSectionVisibility(true);
    }
  };

  const registerClient = () => {
    if (validateEmail(email)) {
      setGeneralDetails({
        email,
      });
      dispatch(
        registerClientApi({
          email,
        })
      );
    } else {
      toast.error("Please enter your work email.");
    }
  };

  const openLinkedIn = (user: string) => {
    ChangeHistory("blank", `https://www.linkedin.com/in/${user}`);
  };

  //Return UI
  return (
    <Screen
      className="about-us-screen"
      hasHeader
      hasFooter
      screenAnimationClass="no-animation"
    >
      {/* First Section */}
      <FlexBox
        justifyBetween
        alignCenter
        className={cx(
          window.screen.width > 968 && "mr-t-50",
          "pd-h-60 desktop-mobile landing-div"
        )}
      >
        <div className="w-100 text-center pd-v-30 animated fadeInLeft">
          <p className="fs-28 animated fadeInUp delay-03s font-heavy mr-b-30">
            OTPless powers mobile identity for the internet.
          </p>
          <p className="fs-44 mr-b-20 font-heavy animated fadeInUp delay-01s">
            Our <span className="clr-theme">Vision</span>
          </p>
          <div className=" ">
            <p className="fs-18 animated fadeInUp delay-03s">
              {" "}
              Aptly named, OTPless is on a mission to remove OTPs
              (one-time-passwords) from our lives by providing a trusted,
              secure, and easy way of verifying a mobile number on interenet.
            </p>
            <FlexBox
              justifyBetween
              alignTop
              className="mr-v-30 animated fadeInUp delay-03s counts"
            >
              <div className="w-33">
                <p className="fs-36 font-heavy clr-theme">5.5M+</p>
                <p className="fs-14 font-medium">Users Authenticated</p>
              </div>
              <div className="w-33">
                <p className="fs-36 font-heavy clr-theme">26%</p>
                <p className="fs-14 font-medium">Higher Conversion</p>
              </div>
              <div className="w-33">
                <p className="fs-36 font-heavy clr-theme">0</p>
                <p className="fs-14 font-medium">Security Incidence</p>
              </div>
            </FlexBox>
          </div>
          {/* <Button
            rounded
            text={
              <FlexBox alignCenter justifyCenter>
                <p className="fs-20 clr-white">Go OTPless</p>
                <Image
                  src={RightArrowIcon}
                  className={cx("w-8 mr-h-10 arrow-animation")}
                />
              </FlexBox>
            }
            className={cx(goOTPLessClicked && "get-api-button-hidden", "get-api-button fs-16 w-50 mr-t-20 desktop-button")}
            onClick={() => {
              setGoOTPLessClicked(true);
              window.addEventListener("scroll", onScroll, true);
            }}
          /> */}
          <Button
            text={
              <FlexBox alignCenter justifyCenter>
                <p className="fs-20 clr-white">Go Live</p>
                <Image
                  src={RightArrowIcon}
                  className={cx("mr-h-10 arrow-animation")}
                />
              </FlexBox>
            }
            className={cx(
              "br-60 clr-white no-wrap mr-t-20 fs-20 go-otpless987"
            )}
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.TOP_GO_OTPLESS_CLICK
              );
              ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
            }}
          />
        </div>
        {/* <div className="w-50 text-center animated fadeInRight">
          <Image src={LandingImg} className="w-100" />
        </div> */}
      </FlexBox>
      {/* Second Section */}
      <div
        className="team-section pd-h-60 mr-v-40 pd-v-60"
        ref={teamSectionRef}
      >
        <p className="text-center font-heavy fs-44 w-70 mr-au animated fadeInUp delay-01s">
          {" "}
          Our Team
        </p>
        <FlexBox className="mr-v-40" justifyEvenly alignCenter>
          <Card className="w-25 text-center animated fadeInUp delay-02s">
            <div className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 pos-rel">
              <Image src={SatyamImg} className="w-50" />
              <Image
                src={LinkedInLogo}
                className="linked-in-logo curs-point"
                onClick={() => {
                  EventManager.send(
                    EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.PROFILE_CLICK,
                    {
                      [EventNames.EVENTS_PARAMS.WEBSITE.ABOUT_US.NAME]:
                        "Satyam Nathani",
                    }
                  );
                  openLinkedIn("satyamnathani");
                }}
              />
            </div>
            <p className="font-heavy fs-20 mr-t-10 clr-theme">Satyam Nathani</p>
            <p className="fs-16 mr-v-10 font-heavy">Co-founder</p>
            {/* <p className="fs-16 mr-v-10">BharatPe Founding Team</p> */}
            {/* <p className="fs-16">IIT Delhi</p> */}
          </Card>
          <Card className="w-25 text-center animated fadeInUp delay-02s">
            <div className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 pos-rel">
              <Image src={TanmayImg} className="w-50" />
              <Image
                src={LinkedInLogo}
                className="linked-in-logo curs-point"
                onClick={() => {
                  EventManager.send(
                    EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.PROFILE_CLICK,
                    {
                      [EventNames.EVENTS_PARAMS.WEBSITE.ABOUT_US.NAME]:
                        "Tanmay Sagar",
                    }
                  );
                  openLinkedIn("tanmay-sagar");
                }}
              />
            </div>
            <p className="font-heavy fs-20 mr-t-10 clr-theme">Tanmay Sagar</p>
            <p className="fs-16 mr-v-10 font-heavy">Co-founder</p>
            {/* <p className="fs-16 mr-v-10">BharatPe Founding Team</p> */}
            {/* <p className="fs-16">IIT Delhi</p> */}
          </Card>
          <Card className="w-25 text-center animated fadeInUp delay-02s">
            <div className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 pos-rel">
              <Image src={BhavikImg} className="w-50" />
              <Image
                src={LinkedInLogo}
                className="linked-in-logo curs-point"
                onClick={() => {
                  EventManager.send(
                    EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.PROFILE_CLICK,
                    {
                      [EventNames.EVENTS_PARAMS.WEBSITE.ABOUT_US.NAME]:
                        "Bhavik Koladiya",
                    }
                  );
                  openLinkedIn("koladiya");
                }}
              />
            </div>
            <p className="font-heavy fs-20 mr-t-10 clr-theme">
              Bhavik Koladiya
            </p>
            <p className="fs-16 mr-v-10 font-heavy">Innovation</p>
            {/* <p className="fs-16 mr-v-10">MD, Finix Partners</p> */}
          </Card>
        </FlexBox>
        <FlexBox
          className="pd-t-40 animated fadeInUp delay-05s"
          justifyEvenly
          alignCenter
        >
          <Card className="w-25 text-center animated fadeInUp delay-02s">
            <div className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 pos-rel">
              <Image src={AshwinImg} className="w-50" />
              <Image
                src={LinkedInLogo}
                className="linked-in-logo curs-point"
                onClick={() => {
                  EventManager.send(
                    EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.PROFILE_CLICK,
                    {
                      [EventNames.EVENTS_PARAMS.WEBSITE.ABOUT_US.NAME]:
                        "Ashwin Garg",
                    }
                  );
                  openLinkedIn("ashwin-garg-22a94016b");
                }}
              />
            </div>
            <p className="font-heavy fs-20 mr-t-10 clr-theme">Ashwin Garg</p>
            <p className="fs-16 mr-v-10 font-heavy">Engineering</p>
            {/* <p className="fs-16 mr-v-10">Ex. Tesco</p> */}
            {/* <p className="fs-16">IIT Delhi</p> */}
          </Card>
          <Card className="w-25 text-center animated fadeInUp delay-02s">
            <div className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 pos-rel">
              <Image src={ManasImg} className="w-50" />
              <Image
                src={LinkedInLogo}
                className="linked-in-logo curs-point"
                onClick={() => {
                  EventManager.send(
                    EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.PROFILE_CLICK,
                    {
                      [EventNames.EVENTS_PARAMS.WEBSITE.ABOUT_US.NAME]:
                        "Manas Poddar",
                    }
                  );
                  openLinkedIn("manas-poddar-729936104");
                }}
              />
            </div>
            <p className="font-heavy fs-20 mr-t-10 clr-theme">Manas Poddar</p>
            <p className="fs-16 mr-v-10 font-heavy">Growth</p>
            {/* <p className="fs-16 mr-v-10">Ex. BharatPe</p> */}
            {/* <p className="fs-16">IIT Delhi</p> */}
          </Card>
          <Card className="w-25 text-center animated fadeInUp delay-02s">
            <div className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 pos-rel">
              <Image src={ChiragImg} className="w-50" />
              <Image
                src={LinkedInLogo}
                className="linked-in-logo curs-point"
                onClick={() => {
                  EventManager.send(
                    EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.PROFILE_CLICK,
                    {
                      [EventNames.EVENTS_PARAMS.WEBSITE.ABOUT_US.NAME]:
                        "Chirag Bhadiyadra",
                    }
                  );
                  openLinkedIn("chiragbhadiyadra");
                }}
              />
            </div>
            <p className="font-heavy fs-20 mr-t-10 clr-theme">
              Chirag Bhadiyadra
            </p>
            <p className="fs-16 mr-v-10 font-heavy">Growth</p>
            {/* <p className="fs-16 mr-v-10">Ex. BharatPe</p> */}
            {/* <p className="fs-16">GMIT</p> */}
          </Card>
        </FlexBox>
        <FlexBox justifyCenter alignCenter className="w-100 mr-t-40">
          <Button
            text={
              <FlexBox alignCenter justifyCenter>
                <p className="fs-20 clr-white">Go OTPless</p>
                <Image
                  src={RightArrowIcon}
                  className={cx("mr-h-10 arrow-animation")}
                />
              </FlexBox>
            }
            className={cx(
              "br-60 clr-white no-wrap fs-20 go-otpless987 center-action"
            )}
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.ABOUT_US.BOTTOM_GO_OTPLESS_CLICK
              );
              ChangeHistory("push", ROUTE_PATH.DASHBOARD.SIGNUP_LOGIN);
            }}
          />
        </FlexBox>
      </div>
    </Screen>
  );
};

export default Landing;
